import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Loading from '../../Common/Loading';

const EL_ManageKeyWords: React.FC = () => {

    const navigate = useNavigate();

    
  const API_BASE =
    process.env.REACT_APP_DOCUMENT_LINK;


    const [countries] = useState([
        { label: "Australia", value: "AUS" },
        { label: "India", value: "IND" },
        { label: "Singapore", value: "SIN" },
        { label: "Canada", value: "CA" },
        { label: "International", value: "INL" },
        { label: "Malaysia", value: "ma" },
        { label: "NewZeaLand", value: "NZL" },
        { label: "Phillipines", value: "PLP" },
        { label: "UAE", value: "UAE" },
        { label: "UK", value: "UK" },
        { label: "USA", value: "USA" }
    ]);

    const [selectedCountry, setSelectedCountry] = useState('-- Country --');
    const [dics, setDics] = useState<string[]>([]);
    const [selectedDic, setSelectedDic] = useState('');
    const [sortBy, setSortBy] = useState('Lesson Code');
    
    const [gridCols, setGridCols] = useState<string[]>([]);
    const [gridData, setGridData] = useState<any[]>([]);
    
    const [file, setFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.body.style.margin = '0px';
        document.body.style.backgroundColor = '#ffffff';
    }, []);

    // Fetch DICs when Country changes
    useEffect(() => {
        if (selectedCountry === '-- Country --') {
            setDics([]);
            setSelectedDic('');
            return;
        }
        
        const fetchDics = async () => {
            setLoading(true);
            try {
                const res = await fetch(`${API_BASE}api/keywords/dics?country=${selectedCountry}`);
                const json = await res.json();
                setDics(json.dics || []);
                if (json.dics && json.dics.length > 0) setSelectedDic(json.dics[0]);
            } catch (err) {
                console.error("Error fetching DICs", err);
            } finally {
                setLoading(false);
            }
        };
        fetchDics();
    }, [selectedCountry]);

    const handleShow = async () => {
        if (!selectedDic) return;
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}api/keywords/list?dic=${selectedDic}&sort_by=${sortBy}`);
            const json = await res.json();
            if (json.error) alert(json.error);
            else {
                setGridCols(json.columns || []);
                setGridData(json.results || []);
            }
        } catch (err) {
            alert("Error loading keywords grid.");
        } finally {
            setLoading(false);
        }
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const selectedFile = e.target.files[0];
            const ext = selectedFile.name.split('.').pop()?.toLowerCase();
            if (ext !== 'csv') {
                alert("Please select a .csv file.");
                e.target.value = '';
                setFile(null);
            } else {
                setFile(selectedFile);
            }
        }
    };

    const handleUpdate = async () => {
        if (selectedCountry === '-- Country --') {
            alert("Select a Country.");
            return;
        }
        if (!file) {
            alert("Please select a .csv file.");
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('country', selectedCountry);

            const res = await fetch(`${API_BASE}api/keywords/upload`, {
                method: 'POST',
                body: formData
            });
            const json = await res.json();
            
            if (json.error) alert(json.error);
            else alert(json.message);
            
        } catch (err) {
            alert("Error updating keywords.");
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        window.close();
    };

    // --- Styles mapping exactly to the screenshot and eLearnCSS ---
    const styles = {
        container: { margin: '10px', fontFamily: 'Trebuchet MS, Arial, sans-serif', fontSize: '10pt' },
        
        // Main Control Table
        controlTable: { width: '100%', border: 'solid 1px #385D8A', backgroundColor: '#F8F8F8', borderCollapse: 'collapse' as const },
        tdLabel: { padding: '8px', height: '11px', width: '30%' },
        tdContent: { padding: '8px', width: '60%' },
        tdAction: { padding: '8px', width: '10%', textAlign: 'right' as const },
        
        // Borders for specific rows matching the screenshot
        rowBorderTop: { borderTop: 'solid 1px #385D8A' },
        
        select: { width: '98%', padding: '3px', border: '1px solid #A0A0A0', fontFamily: 'Trebuchet MS, Arial', fontSize: '12px' },
        fileInput: { width: '95%', border: 'solid 1px #5B91B5', cursor: 'pointer', padding: '2px', backgroundColor: 'white' },
        
        // Match .cssButtonWithBorder exactly
        btn: { 
            backgroundColor: '#119ECC', 
            color: 'White', 
            fontWeight: 'bold', 
            border: 'solid 2px orange', 
            padding: '4px 15px', 
            cursor: 'pointer',
            fontFamily: 'Trebuchet MS',
            fontSize: '10pt',
            width: '80px'
        },
        
        // Grid Styles
        gridWrapper: { marginTop: '10px', overflowY: 'auto' as const, maxHeight: '600px', border: '1px solid #80a0ff' },
        gridTable: { width: '100%', borderCollapse: 'collapse' as const, fontFamily: 'Trebuchet MS, Arial', fontSize: '10pt' },
        
        // Specific Light Blue headers from the screenshot
        titleRow: { backgroundColor: '#c7ddfd', color: '#2859ac', textAlign: 'center' as const, padding: '5px', fontSize: '10pt', borderBottom: '1px solid #80a0ff' },
        th: { backgroundColor: '#c7ddfd', color: '#2859ac', padding: '6px', textAlign: 'left' as const, fontWeight: 'normal', border: '1px solid #80a0ff' },
        gridTd: { padding: '10px', borderLeft: '1px solid #80a0ff' },
        
        bottomBar: { width: '100%', textAlign: 'center' as const, paddingTop: '15px' }
    };

    return (
        <div style={styles.container}>
            {loading && <Loading />}

            <table style={styles.controlTable}>
                <tbody>
                    <tr>
                        <td style={styles.tdLabel}>&nbsp;&nbsp; Country</td>
                        <td style={styles.tdContent}>
                            <select style={styles.select} value={selectedCountry} onChange={e => setSelectedCountry(e.target.value)}>
                                <option value="-- Country --">-- Country --</option>
                                {countries.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                            </select>
                        </td>
                        <td style={styles.tdAction}></td>
                    </tr>
                    <tr>
                        <td style={styles.tdLabel}>&nbsp;&nbsp; Dic Files having Keywords:</td>
                        <td style={styles.tdContent}>
                            <select style={{ ...styles.select, width: '40%', marginRight: '15px' }} value={selectedDic} onChange={e => setSelectedDic(e.target.value)}>
                                {dics.map(d => <option key={d} value={d}>{d}</option>)}
                            </select>
                            Sort By:&nbsp;
                            <select style={{ ...styles.select, width: '43%' }} value={sortBy} onChange={e => setSortBy(e.target.value)}>
                                <option value="Lesson Code">Lesson Code</option>
                                <option value="Lesson Name">Lesson Name</option>
                                <option value="KeyWord">KeyWord</option>
                            </select>
                        </td>
                        <td style={styles.tdAction}>
                            <button style={styles.btn} onClick={handleShow}>Show</button>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ ...styles.tdLabel, ...styles.rowBorderTop }}>&nbsp;&nbsp; Import from CSV file:</td>
                        <td style={{ ...styles.tdContent, ...styles.rowBorderTop }}>
                            &nbsp;<input type="file" accept=".csv" style={styles.fileInput} onChange={handleFileChange} />
                        </td>
                        <td style={{ ...styles.tdAction, ...styles.rowBorderTop }}>
                            <button style={styles.btn} onClick={handleUpdate}>Update</button>
                        </td>
                    </tr>
                </tbody>
            </table>

            {gridCols.length > 0 && (
                <div style={styles.gridWrapper}>
                    <table style={styles.gridTable}>
                        <thead>
                            <tr>
                                <th colSpan={gridCols.length + 1} style={styles.titleRow}>
                                    Keywords pertaining to DIC : {selectedDic}
                                </th>
                            </tr>
                            <tr>
                                <th style={styles.th}>#</th>
                                {gridCols.map(col => <th key={col} style={styles.th}>{col}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {gridData.map((row, idx) => {
                                const prevRow = idx > 0 ? gridData[idx - 1] : null;
                                return (
                                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? 'white' : '#F4FAFF' }}>
                                        <td style={styles.gridTd}>{idx + 1}</td>
                                        {gridCols.map(col => {
                                            // Replicate "SuppressRepeatData=True" logic by graying out repeated previous values
                                            const isSuppressed = prevRow && prevRow[col] === row[col] && (col === 'LessonCode' || col === 'LessonName');
                                            return (
                                                <td key={col} style={{ ...styles.gridTd, color: isSuppressed ? '#c0c0c0' : 'black' }}>
                                                    {row[col]}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            <div style={styles.bottomBar}>
                <button style={{ ...styles.btn, width: '100px' }} onClick={() => navigate("/SysAdmin")}>Cancel</button>
            </div>
        </div>
    );
};

export default EL_ManageKeyWords;